import { render, staticRenderFns } from "./RptSendPaymentResult.vue?vue&type=template&id=47b1b310&"
import script from "./RptSendPaymentResult.vue?vue&type=script&lang=ts&"
export * from "./RptSendPaymentResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports